import AbsList from "./AbsList";
import Util from "../Util";

export const SEARCH_PARAM = {
  KEYWORD: 'keyword',
  PAGE: 'page',
  SIZE: 'size',
  FIELD: 'field',
  SORT: 'sort',
  VIDEO_KIND: 'videoKind'
};

export const SEARCH_VIDEO_KIND = {
  USER: "0",
  OFFICIAL: "1",
  ESPORTS: "2",
  OST: "3"
};

export const SEARCH_LIVE_STATUS = ["none", "live", "finish"];

export const SEARCH_FIELD = {
  GAME_DATA: 'game_data'
}

class SearchAbsList extends AbsList {
  constructor(_option={}, _alias='', _container='') {
    super(_option, _alias, _container);

    this.order = _option.order ? _option.order : '';
    this.filter = _option.filter || '';
    this.gamelog =  this.filter ?  this.filter.indexOf(SEARCH_FIELD.GAME_DATA) > -1 : false;
    this.official = (this.videoKind == SEARCH_VIDEO_KIND.OFFICIAL) ? true : false;

    this.addElements();
    this.addEvents();
    this.init();
  }

  loadListData() {
    $.ajax({
      type: "GET",
      contentType: "application/json",
      url: `${this.apiDomain}/${this.com.ip}/search/v2/video`,
      async: "false",
      data: this.getDataParams(),
    })
      .fail((_e) => {
        console.log(_e);
      })
      .done((_d) => {
        this.listData = this.setSearchDataV2(_d);
        this.setTemplate();
        this.toggleMoreButton();
        this.toggleEmpty();
        $(".contents").trigger("LOAD_LIST_DATA", this.listData);
      });
  }

  // ajax에서 사용할 파라미터
  getDataParams() {
    return {
      [SEARCH_PARAM.KEYWORD]: this.query,
      [SEARCH_PARAM.VIDEO_KIND]: this.videoKind,
      [SEARCH_PARAM.PAGE]: this.page,
      [SEARCH_PARAM.SIZE]: 20,
      [SEARCH_PARAM.SORT]: this.order,
      [SEARCH_PARAM.FIELD]: this.filter
    };
  }

  // 검색 API v2 데이터를 v1 데이터 구조로 변경
  setSearchDataV2(data = {}) {
    const { list, pagination } = data || {};
    const { page, size, total, endPage } = pagination || {};

    const content =
      Array.isArray(data.list) && data.list.length > 0
        ? list.map((v) => {
            const {
              videoId,
              videoThumbnail,
              title,
              channelThumbnail,
              channelName,
              updatedDatetime,
              ncStreaming,
              videoType,
              liveStatus,
              gameData,
              provider,
              playtime,
              providerLikeCount,
              zone,
            } = v || {};
            return {
              id: videoId,
              thumbnail: videoThumbnail,
              title,
              channelThumbnail,
              channelName,
              updateDate: updatedDatetime,
              ncstreaming: ncStreaming,
              videoType,
              liveStatus: SEARCH_LIVE_STATUS[liveStatus],
              gameData,
              provider,
              playtime,
              providerLikeCount,
              zone: {
                zoneName: zone,
              },
            };
          })
        : [];

    return {
      content,
      contentSize: size,
      totalCount: total,
      pageSize: size,
      totalPages: endPage,
      page,
      last: page === endPage,
    };
  }

  //게임로그 옵션 선택
  clickGamelogOption() {
    if (this.el.GamelogOption.prop("checked")) {
      window.location.href = Util.addParam(
        SEARCH_PARAM.FIELD,
        SEARCH_FIELD.GAME_DATA);
    } else {
      window.location.href = Util.removeParam(SEARCH_PARAM.FIELD, SEARCH_FIELD.GAME_DATA);
    }
  }

  //공식영상 옵션 선택
  clickOfficialOption() {
    if (this.el.OfficialOption.prop("checked")) {
      window.location.href = Util.addParam(
        SEARCH_PARAM.VIDEO_KIND,
        SEARCH_VIDEO_KIND.OFFICIAL
      );
    } else {
      window.location.href = Util.removeParam(SEARCH_PARAM.VIDEO_KIND, SEARCH_VIDEO_KIND.OFFICIAL);
    }
  }
} // end of class
export default SearchAbsList;
